<template>
  <div data-position="in" :data-pc-key="config.key" class="vux-tabpanel-item">
    <component v-for="c in children" :key="c.key" :is="c.configComponent" :endpoint="endpoint" :group="group" :config="c" @remove="removeChild" ref="childComponents"></component>
  </div>
</template>

<script>
import mixin from './mixin.js'

export default {
  name: 'vux-tabpanel-item-component',
  mixins: [mixin],
  data () {
    return {
      properties: {
        label: null,
        icon: null,
        activeIcon: null
      }
    }
  }
}
</script>

<style>
.vux-tabpanel-item{height:600px;overflow:auto;}
</style>
